export default "__VITE_ASSET__D02l$l7c__"